import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Drawer } from '@printdeal/ui-library';

import useSystemPages from '../../../hooks/useSystemPages';

import ModalContentLogin from './ModalContentLogin';
import ModalContentLostPassword from './ModalContentLostPassword';

interface LoginDrawerModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (state: boolean) => void;
  queryParamsForRegistrationLink?: string;
}

const LoginDrawerModal = ({ isModalOpen, setIsModalOpen, queryParamsForRegistrationLink = '' }: LoginDrawerModalProps) => {
  const intl = useIntl();
  const [modalView, setModalView] = useState('login');
  const [lostPasswordPage] = useSystemPages(
    'lostPassword',
  );

  return (
    <Drawer
      isOpen={isModalOpen}
      onClose={setIsModalOpen}
      title={modalView === 'login' ? intl.formatMessage({
        id: 'login.slideout.loginTitle',
        defaultMessage: 'Log into your account',
      }) : lostPasswordPage.title}
      position="right"
      dismissLabel={intl.formatMessage({
        id: 'account.general.modal.close',
        defaultMessage: 'Close',
      })}
    >
      {modalView === 'login' ? (
        <ModalContentLogin
          setModalView={setModalView}
          setIsModalOpen={setIsModalOpen}
          queryParamsForRegistrationLink={queryParamsForRegistrationLink}
        />
      ) : (
        <ModalContentLostPassword setModalView={setModalView} />
      )}
    </Drawer>
  );
};

export default LoginDrawerModal;
